import { render, staticRenderFns } from "./PointsSettingsRevisionHistory.vue?vue&type=template&id=58844484&scoped=true"
import script from "./PointsSettingsRevisionHistory.vue?vue&type=script&lang=js"
export * from "./PointsSettingsRevisionHistory.vue?vue&type=script&lang=js"
import style0 from "./PointsSettingsRevisionHistory.vue?vue&type=style&index=0&id=58844484&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58844484",
  null
  
)

export default component.exports